<template>
  <fragment>
    <template>
      <b-button
        block
        @click.prevent
        v-b-toggle="'contact-details-' + id"
        variant="light"
        class="mb-2"
        v-if="status === 'quoted' || status === 'won' || status === 'repwon'"
      >
        <span class="when-opened">
          <b-icon-chevron-up></b-icon-chevron-up> {{ $t('buttons.show_less') }}
        </span>
        <span class="when-closed">
          <b-icon-plus-circle></b-icon-plus-circle>
          {{ $t('project_details.contact_customer') }}
        </span>
      </b-button>

      <b-collapse
        :id="'contact-details-' + id"
        v-if="status === 'quoted' || status === 'won' || status === 'repwon'"
      >
        <ContactDetails
          :title="buyerName"
          :email="buyerEmail"
          :telephone="buyerPhone"
        />
      </b-collapse>

      <b-button
        block
        @click.prevent
        v-b-toggle="'project-details-' + id"
        variant="light"
        class="mb-2"
      >
        <span class="when-opened">
          <b-icon-chevron-up></b-icon-chevron-up> {{ $t('buttons.show_less') }}
        </span>
        <span class="when-closed">
          <b-icon-plus-circle></b-icon-plus-circle>
          {{ $t('project_details.project_details') }}
        </span>
      </b-button>

      <b-collapse :id="'project-details-' + id">
        <ProjectDetails :id="projectId" :status="status" :location="location" />
      </b-collapse>
    </template>

    <b-card no-body>
      <div class="card-header">
        <b-alert show dismissible :variant="alertVariant" v-if="showAlert">
          <h3 class="alert-heading" v-if="alertTitle">{{ alertTitle }}</h3>
          <div v-html="alertMsg" />
        </b-alert>

        <div class="text-right">
          <!-- <b-button-group v-if="status === 'quoted'">
            <b-button
              :disabled="submitting"
              variant="outline-success"
              v-b-modal="'modal_won' + id"
            >
              <b-icon-check-circle></b-icon-check-circle>
              {{ $t('buttons.won') }}
            </b-button>
            <b-button
              :disabled="this.submitting"
              variant="outline-danger"
              v-b-modal="'modal_lost' + id"
            >
              <b-icon-x-circle></b-icon-x-circle>
              {{ $t('buttons.lost') }}
            </b-button>
          </b-button-group> -->
        </div>
        <b-icon icon="chat-right-text" />
        {{ $t('quote.title') }}
      </div>
      <b-list-group flush>
        <b-list-group-item v-if="project.labourCost">
          <strong>{{ $t('quote_form.labour_cost') }}:</strong>
          {{ project.labourCost | currency(currency) }}
        </b-list-group-item>
        <b-list-group-item v-if="project.materialCost">
          <strong>{{ $t('quote_form.material_cost') }}:</strong>
          {{ project.materialCost | currency(currency) }}
        </b-list-group-item>
        <b-list-group-item v-if="project.otherCost">
          <strong>{{ $t('quote_form.other_cost') }}:</strong>
          {{ project.otherCost | currency(currency) }}
        </b-list-group-item>
        <b-list-group-item v-if="project.totalCost">
          <strong>{{ $t('quote_form.total_cost') }}:</strong>
          {{ project.totalCost | currency(currency) }}
        </b-list-group-item>
        <b-list-group-item v-if="sumTotalCostVAT() > 0">
          <strong>{{ $t('quote_form.total_cost_vat_label') }}:</strong>
          {{ sumTotalCostVAT() | currency(currency) }}
        </b-list-group-item>
        <b-list-group-item v-if="status === 'won' && provisionPercent > 0">
          <strong>{{ $t('project_details.commission_label') }}:</strong>
          {{ provisionPercent | decimalSingle }} %
        </b-list-group-item>
        <b-list-group-item v-if="status === 'won'">
          <strong>{{ $t('project_details.due_date_label') }}:</strong>
          {{ debitDate | date }}
        </b-list-group-item>
      </b-list-group>

      <b-card-body v-if="project.notification">
        {{ project.notification }}
      </b-card-body>

      <b-card-body>
        <b-embed
          width="100%"
          height="auto"
          v-if="fileExist"
          type="iframe"
          :src="
            this.api_url +
              '/getcurrentquotefile?provisionLeadId=' +
              id +
              '&token=' +
              api_token
          "
        />

        <b-link
          v-if="fileExist"
          target="_blank"
          :href="
            api_url +
              '/getcurrentquotefile?provisionLeadId=' +
              id +
              '&token=' +
              api_token
          "
          >{{ $t('quote_form.download') }}
        </b-link>
      </b-card-body>

      <b-card-footer
        v-if="status === 'quoted' || status === 'repwon' || status === 'lost'"
      >
        <router-link
          :to="'/view-project/' + id"
          v-slot="{ href, navigate }"
          v-if="status === 'quoted'"
        >
          <b-button
            type="button"
            :href="href"
            @click="navigate"
            variant="outline-primary"
            :disabled="this.submitting"
            >{{ $t('quote_form.edit_quote') }}</b-button
          >
        </router-link>

        <b-button-group v-if="status === 'repwon'">
          <b-button
            :disabled="this.submitting"
            variant="outline-success"
            v-b-modal="'modal_won' + id"
          >
            <b-icon-check-circle></b-icon-check-circle>
            {{ $t('buttons.confirm') }}
          </b-button>
          <b-button
            :disabled="this.submitting"
            variant="outline-danger"
            v-b-modal="'modal_declined' + id"
          >
            <b-icon-x-circle></b-icon-x-circle>
            {{ $t('buttons.decline') }}
          </b-button>
        </b-button-group>

        <b-button-group class="controls">
          <b-button-group v-if="status === 'quoted'">
            <b-button
              :disabled="this.submitting"
              variant="outline-success"
              v-b-modal="'modal_won' + id"
            >
              <b-icon-check-circle></b-icon-check-circle>
              {{ $t('buttons.won') }}
            </b-button>
            <b-button
              :disabled="this.submitting"
              variant="outline-danger"
              v-b-modal="'modal_lost' + id"
            >
              <b-icon-x-circle></b-icon-x-circle>
              {{ $t('buttons.lost') }}
            </b-button>
          </b-button-group>
        </b-button-group>

        <b-button
          v-if="status === 'lost' || status === 'declined'"
          :disabled="this.submitting"
          variant="primary"
          @click="revertReportedStatus"
        >
          <b-icon icon="check-circle" />
          {{ $t('buttons.set_to_quoted') }}
        </b-button>
        <div>
          <i v-if="status === 'quoted' || status === 'repwon'"
            ><small
              class="text-muted"
              v-html="
                $t(`quote.${status}_tagline`, {
                  amount: this.$options.filters.currency(
                    getPercentageTotalCost(status === 'repwon' ? 1 : 2),
                    currency,
                  ),
                  amount_vat: this.$options.filters.currency(
                    getPercentageTotalCost(status === 'repwon' ? 1 : 2) *
                      (user.country === 'SE' ? 1.25 : 1.2),
                    currency,
                  ),
                })
              "
          /></i>
        </div>
      </b-card-footer>
    </b-card>
    <LeadConfirmModal
      :modalId="`modal_won${id}`"
      :title="$t('buttons.won')"
      :body="$t('messages.actions.confirm_msg_won')"
      :buyerName="buyerName"
      :location="location"
      :totalCost="project['totalCost']"
      :currency="currency"
      :currentStatus="status"
      targetStatus="won"
      :provisionPercent="provisionPercent"
      :actionButtonText="$t('buttons.won')"
      actionButtonVariant="outline-success"
      actionButtonIcon="check-circle"
      @confirm="
        ({ paymentPreference, declinedReason }) =>
          status === 'quoted'
            ? reportWon(paymentPreference)
            : acceptReportedWin(true, paymentPreference, declinedReason)
      "
    />

    <LeadConfirmModal
      :modalId="`modal_lost${id}`"
      :title="$t('buttons.lost')"
      :body="$t('messages.actions.confirm_msg_lost')"
      :buyerName="buyerName"
      :location="location"
      :totalCost="project['totalCost']"
      :currency="currency"
      :currentStatus="status"
      targetStatus="lost"
      :actionButtonText="$t('buttons.lost')"
      actionButtonVariant="outline-danger"
      actionButtonIcon="x-circle"
      @confirm="({ paymentPreference, declinedReason }) => reportLost()"
    />

    <LeadConfirmModal
      :modalId="`modal_declined${id}`"
      :title="$t('buttons.decline')"
      :body="$t('messages.actions.confirm_msg_lost')"
      :buyerName="buyerName"
      :location="location"
      :totalCost="project['totalCost']"
      :currency="currency"
      :currentStatus="status"
      targetStatus="declined"
      :actionButtonText="$t('buttons.lost')"
      actionButtonVariant="outline-danger"
      actionButtonIcon="x-circle"
      @confirm="
        ({ paymentPreference, declinedReason }) =>
          acceptReportedWin(false, null, declinedReason)
      "
    />
  </fragment>
</template>
<script>
import api from '../api/api';
import ProjectDetails from '@/components/ProjectDetails.vue';
import ContactDetails from '@/components/ContactDetails.vue';
import LeadConfirmModal from '@/components/LeadConfirmModal.vue';

export default {
  components: {
    ProjectDetails,
    ContactDetails,
    LeadConfirmModal,
  },
  props: {
    id: {
      type: Number,
    },
    projectId: {
      type: Number,
    },
    status: {
      type: String,
    },
    vat: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
    },
    buyerName: {
      type: String,
    },
    buyerEmail: {
      type: String,
    },
    buyerPhone: {
      type: String,
    },
    location: {
      type: String,
    },
    provisionPercent: {
      type: Number,
      default: 0,
    },
    debitDate: {
      type: String,
    },
  },
  data() {
    return {
      project: [],
      fileExist: false,
      api_url: process.env.VUE_APP_API_URL,
      api_token: sessionStorage.getItem('api_token'),
      submitting: false,
      showAlert: false,
      alertVariant: 'success',
      alertTitle: '',
      alertMsg: '',
    };
  },
  mounted() {
    this.getCurrentQuote();
    this.checkProjectFileExist();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getCurrentQuote() {
      api
        .getCurrentQuote(this.id)
        .then((res) => (this.project = res.data))
        .catch((err) => err);
    },
    checkProjectFileExist() {
      api
        .getCurrentQuoteFilename(this.id)
        .then((res) =>
          res.data != 0 ? (this.fileExist = true) : (this.fileExist = false),
        )
        .catch((err) => err);
    },
    acceptReportedWin(accept, paymentPreference, declinedReason) {
      this.$emit('submit');

      if (accept) this.$bvModal.hide(`modal_won${this.id}`);
      if (!accept) this.$bvModal.hide(`modal_declined${this.id}`);

      this.submitting = true;

      api
        .acceptReportedWin(
          this.id,
          accept,
          declinedReason,
          accept ? paymentPreference : null,
        )
        .then((res) => {
          if (res.data && res.data.reason === 'CARD_PAYMENT_FAILURE') {
            if (confirm(this.$t('pages.payment_confirmation.payment_failed'))) {
              this.$router.push({
                name: 'Payment',
                params: { userId: this.user.userId },
              });
            }
          }

          this.showAlert = true;
          this.alertTitle = this.$t('messages.success');

          accept
            ? (this.alertMsg = this.$t('messages.actions.quote_won'))
            : (this.alertMsg = this.$t('messages.actions.quote_lost'));
        })
        .catch((err) => err)
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    reportWon(paymentPreference) {
      this.$emit('submit');

      this.$bvModal.hide('modal_won' + this.id);
      this.submitting = true;

      api
        .reportProvisionLeadWon(this.id, paymentPreference)
        .then((res) => {
          if (res.data && res.data.reason === 'CARD_PAYMENT_FAILURE') {
            if (confirm(this.$t('pages.payment_confirmation.payment_failed'))) {
              this.$router.push({
                name: 'Payment',
                params: { userId: this.user.userId },
              });
            }
          }

          this.showAlert = true;
          this.alertTitle = this.$t('messages.success');
          this.alertMsg = this.$t('messages.actions.quote_won');
        })
        .catch((err) => err)
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    reportLost() {
      this.$emit('submit');

      this.$bvModal.hide('modal_lost' + this.id);
      this.submitting = true;

      api
        .reportProvisionLeadLost(this.id)
        .then(() => {
          this.showAlert = true;
          this.alertTitle = this.$t('messages.success');
          this.alertMsg = this.$t('messages.actions.quote_lost');
        })
        .catch((err) => err)
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    revertReportedStatus() {
      this.$emit('submit');
      this.submitting = true;

      api
        .revertReportedStatus(this.id)
        .then(() => {
          this.$router.push({
            name: 'View lead',
            params: { id: this.id, method: 'edit' },
          });
          this.reloadPage();
        })
        .catch((err) => err)
        .finally(() => setTimeout(() => (this.submitting = false), 5000));
    },
    sumTotalCostVAT() {
      return Math.round(
        (parseInt(this.project.totalCost) || 0) +
          ((parseInt(this.project.totalCost) || 0) / 100) * this.vat,
      );
    },
    getPercentageTotalCost(percentage) {
      return (this.project.totalCost / 100) * percentage;
    },
    reloadPage() {
      window && window.location.reload();
    },
  },
};
</script>
<style lang="scss" src="../assets/scss/projectForm.scss" scoped />
